/**
 * The live frame's navigate seam.
 *
 * CAOS-326 put this on the shell frame so a floating surface (the report panel) could send somebody
 * somewhere without being handed the whole runtime. CAOS-497 gave it a second caller — a `card_grid`
 * placed as a page section, whose cards carry the route they open — and two surfaces sharing one
 * module-level seam is what this file is. Keeping it here rather than in `shell-frame.ts` is not
 * tidying: `page-surface.ts` must not import the frame, because the frame is what draws pages.
 *
 * It falls back to a real document load when no frame has registered a navigate, so a control is
 * never a dead end. That fallback is the whole point — it is what makes a card safe to click in a
 * test harness, a fixture, or any surface rendered outside the assembled frame.
 */
let activeNavigate: ((href: string) => void) | undefined;

/** Register the frame's navigate function (called by `assembleShellFrame`). */
export function setActiveNavigate(fn: ((href: string) => void) | undefined): void {
  activeNavigate = fn;
}

/** Navigate from a surface that does not hold the runtime. */
export function navigateFromFrame(href: string): void {
  if (activeNavigate) activeNavigate(href);
  else if (typeof location !== 'undefined') location.assign(href);
}
